module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/85570080fe7f5e594bfa14856068709e.png";